import { EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthMethodViewModel } from '../../../../services/identity';
import { FormStatusData } from '../../enrollment.component';
import { EnrollmentInputModel } from '../../../enrollment/models/enrollmentinput.model';

export abstract class MethodBase implements OnInit, OnDestroy {
    @Input() options!: EnrollmentInputModel;
    @Input() method: AuthMethodViewModel;
    @Input() isEditing: boolean;
    @Output() formStatusChanged: EventEmitter<FormStatusData> = new EventEmitter();
    protected subscriptions = new Subscription();
    public form: FormGroup;

    protected isSelf: boolean;

    ngOnInit(): void {
        this.isSelf = this.options.user.id == 0 || this.options.currentUser.id == this.options.user.id;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    monitorFormStatus(): void {
        let data = { sequence: this.method.sequence, index: 0, status: this.form.status, touched: false }
        this.formStatusChanged.emit(data);

        this.subscriptions.add(this.form.statusChanges.subscribe((status) => {
        let data = { sequence: this.method.sequence, index: 0, status: status, touched: true }
        this.formStatusChanged.emit(data);
        }));
    }

    startEdit(): void { }
    endEdit(): void { }

    abstract setup(): void;
    abstract cancel(): void;
    abstract getMethod(): AuthMethodViewModel;
}
